import React from 'react'
import {Foot, Header} from "gyyx-component-lib";
import Routes from '../../routes/routes'
import {connect} from "react-redux";
import {blackPage} from '../../page/mybill/service'

const Layout = (props) => {
  console.log(props)
  const {updateLogin,setLoginStatus} = props

  blackPage().then(res => {
    if (res.data) {
      document.documentElement.style.filter = 'grayscale(100%)';
    }
  })

  const onLoginStatus = (res) => {
    console.log(res)
    setLoginStatus(res)
  }

   return <>
     <Header updateLogin={updateLogin} onLoginStatus={onLoginStatus} loginMode='MergeLogin'></Header>
     <Routes />
     <Foot footId='mall-footer'></Foot>
   </>
}
const mapStateToProps= (state) => state.login;
const mapDispatchToProps = (dispatch) => dispatch.login;

export default connect(mapStateToProps,mapDispatchToProps)(Layout)